import './Contribua.css';

function Contribua() {
  return (
    <div className="global-pageContainer-left">
      <div className="contribute-container">
        <h1>Contribua com o projeto 💜</h1>
        <p>
          O <strong>Tabuada Divertida</strong> é um projeto gratuito, feito com carinho para ajudar estudantes a praticarem matemática de forma leve e divertida.
        </p>
        <p>
          Se você gostou do site e quiser apoiar o projeto, qualquer contribuição é muito bem-vinda!
        </p>

        <h2>💸 Faça uma doação:</h2>
        <ul>
          <li><span>Pix:</span> rodrigoborgesmachado@gmail.com</li>
        </ul>

        <h2>🤝 Outras formas de ajudar:</h2>
        <ul>
          <li>Compartilhe o site com amigos, familiares e professores</li>
          <li>Divulgue nas redes sociais ou grupos escolares</li>
          <li>Envie sugestões ou feedbacks</li>
        </ul>

        <p className="contribute-footer">
          Obrigado por fazer parte dessa jornada! 💙
        </p>
      </div>
    </div>
  );
}

export default Contribua;
